module.exports = __webpack_public_path__ + "static/img/store.1134a39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/store.png
// module id = sS4C
// module chunks = 1